var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { BodyPartPickerGender, BodyPartPickerSide } from "../../types";
import FrontMalePicker from "../male/FrontMalePicker";
import FrontFemalePicker from "../female/FrontFemalePicker";
import BackMalePicker from "../male/BackMalePicker";
import BackFemalePicker from "../female/BackFemalePicker";
import BothMalePicker from "../male/BothMalePicker";
import BothFemalePicker from "../female/BothFemalePicker";
const PickerComponentMap = {
    [BodyPartPickerSide.Front]: {
        [BodyPartPickerGender.Male]: FrontMalePicker,
        [BodyPartPickerGender.Female]: FrontFemalePicker,
    },
    [BodyPartPickerSide.Back]: {
        [BodyPartPickerGender.Male]: BackMalePicker,
        [BodyPartPickerGender.Female]: BackFemalePicker,
    },
    [BodyPartPickerSide.Both]: {
        [BodyPartPickerGender.Male]: BothMalePicker,
        [BodyPartPickerGender.Female]: BothFemalePicker,
    },
};
const PartsPicker = (_a) => {
    var { gender, side } = _a, props = __rest(_a, ["gender", "side"]);
    const Component = PickerComponentMap[side][gender];
    return React.createElement(Component, Object.assign({}, props));
};
export { PartsPicker };
export default PartsPicker;
//# sourceMappingURL=PartsPicker.js.map